import { useState } from 'react';
import { useCarrinhoCompras } from '../../contexts/CarrinhoComprasContext';
import styles from './ModalAdicionarItem.module.css';

const ModalAdicionarItem = ({ produto, onClose }) => {
  const { adicionarItem, getQuantidade } = useCarrinhoCompras();
  const qtdAtual = getQuantidade(produto.codigo || produto.codigoInterno);
  const [quantidade, setQuantidade] = useState(qtdAtual > 0 ? qtdAtual : 1);

  const nome = produto.nome || produto.descricao || '';
  const codigo = produto.codigo || produto.codigoInterno || '';
  const precoCusto = produto.precoCusto || 0;
  const fornecedor = produto.fornecedor || 'Sem fornecedor';

  const formatarMoeda = (v) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

  const handleConfirmar = () => {
    const qtd = Number(quantidade);
    if (!isNaN(qtd) && qtd > 0) {
      adicionarItem(produto, qtd);
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleConfirmar();
    if (e.key === 'Escape') onClose();
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.headerIcon}>🛒</div>
          <div>
            <div className={styles.headerTitle}>Adicionar à Lista</div>
            <div className={styles.headerFornecedor}>{fornecedor}</div>
          </div>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div className={styles.body}>
          <div className={styles.produtoNome} title={nome}>{nome}</div>
          <div className={styles.produtoCodigo}>#{codigo}</div>

          {precoCusto > 0 && (
            <div className={styles.precoCusto}>
              <span className={styles.precoLabel}>Custo unitário:</span>
              <span className={styles.precoValor}>{formatarMoeda(precoCusto)}</span>
            </div>
          )}

          <div className={styles.quantidadeRow}>
            <label className={styles.quantidadeLabel} htmlFor="modal-qtd-input">
              Quantidade (em dúzias):
            </label>
            <div className={styles.quantidadeControls}>
              <button
                className={styles.qtdBtn}
                onClick={() => setQuantidade(q => Math.max(1, Number(q) - 1))}
              >−</button>
              <input
                id="modal-qtd-input"
                type="number"
                className={styles.qtdInput}
                value={quantidade}
                min={1}
                onChange={e => setQuantidade(e.target.value)}
                onKeyDown={handleKeyDown}
                autoFocus
              />
              <button
                className={styles.qtdBtn}
                onClick={() => setQuantidade(q => Number(q) + 1)}
              >+</button>
            </div>
            <div style={{ textAlign: 'center', marginTop: '6px', color: 'rgba(255,255,255,0.4)', fontSize: '0.78rem' }}>
              {Number(quantidade) > 0 && (
                <span>{Number(quantidade)} dz = <strong style={{ color: '#94a3b8' }}>{Number(quantidade) * 12} unidades</strong></span>
              )}
            </div>
          </div>

          {precoCusto > 0 && Number(quantidade) > 0 && (
            <div className={styles.subtotal}>
              <span>Subtotal estimado:</span>
              <span className={styles.subtotalValor}>
                {formatarMoeda(precoCusto * Number(quantidade) * 12)}
              </span>
            </div>
          )}
        </div>

        <div className={styles.footer}>
          <button className={styles.btnCancelar} onClick={onClose}>Cancelar</button>
          <button className={styles.btnConfirmar} onClick={handleConfirmar}>
            <i className="fas fa-plus me-1"></i>
            Adicionar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalAdicionarItem;
